"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("vue-router"));
var routing_1 = require("../tracking/bea/routing");
var routing_2 = require("../tracking/searching/routing");
exports.default = (function ($store) {
    return {
        beforeEach: function (to, from, next) {
            try {
                // add tracking logic
                routing_1.default.beforeEach($store, to, from);
                routing_2.default.beforeEach($store, to, from);
            }
            catch (error) {
                console.log(error);
            }
            if (next) {
                next();
            }
            return false;
        },
        afterEach: function (to, from) {
            try {
                // add tracking logic
                routing_1.default.afterEach($store, to, from);
                routing_2.default.afterEach($store, to, from);
            }
            catch (error) {
                console.log(error);
            }
            return false;
        }
    };
});
//# sourceMappingURL=handler.js.map